import {useMutation, useQueryClient} from '@tanstack/react-query';

import {QUERY__TOPIC_EVENTS} from '@entities/topic/queryKeys';
import {updateEventGroup, UpdateEventGroupParams} from '../api';
import {QUERY__EVENT, QUERY__EVENTS} from '../queryKeys';

export const useUpdateEventGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateEventGroupParams) => updateEventGroup(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__EVENTS]});
      void queryClient.invalidateQueries({queryKey: [QUERY__EVENT]});
      void queryClient.invalidateQueries({queryKey: [QUERY__TOPIC_EVENTS]});
    },
  });
};
